import { Map, fromJS } from 'immutable';
import * as actions from '../utils/Constants'

export default (state = getInitialState(), action) => {
    switch (action.type) {
        case actions.NEW_JURISDICTION:
            {
                return getInitialState();
            }
        case actions.GET_JURISDICTION + actions.FULFILLED:
            {
                return fromJS(action.payload);
            }
        case actions.SAVE_JURISDICTION + actions.FULFILLED:
            {
                return fromJS(action.payload);
            }
        case actions.UPDATE_JURISDICTION_NAME:
            {
                return state.set('name', action.payload)
            }
        case actions.UPDATE_JURISDICTION_STATE:
            {
                return state.set('stateId', action.payload)
            }
        case actions.UPDATE_JURISDICTION_CITY:
            {
                return state.set('city', action.payload)
            }
        case actions.UPDATE_JURISDICTION:
            {
                return state.set(action.payload.field, action.payload.value)
            }
        default:
            return state;
    }
}

const getInitialState = () => {
    return Map({});
}